<template>
  <div>
    <eco-date
      v-model="inputVal"
      :validate="inputValidate"
      :name="inputName"
      :showDate="showDate"
      :day="day"
      :disabled="!isEdit"
      :format="inputFormat"
      :model-expression="modelExpression"
      :value-format="transInputFormat"
      :permission="permission"
      v-if="selectType == 'date'"
    />
    <eco-time-select
      v-model="inputVal"
      :permission="permission"
      :model-expression="modelExpression"
      :validate="inputValidate"
      v-if="selectType == 'select'"
    />
    <eco-time-picker
      v-model="inputVal"
      :permission="permission"
      :model-expression="modelExpression"
      :validate="inputValidate"
      v-if="selectType == 'picker'"
    />
  </div>
</template>
<script>
import utils from "@/utils.js";

export default {
  name: "eip-date",
  props: [
    "validate",
    "name",
    "value",
    "permission",
    "selectType",
    "configAttributes",
    "showDate",
    "day",
    "inputFormat",
    "modelExpression",
    "format"
  ],
  data() {
    return {
      isEdit: true,
      type: "datetime",
      compareType: "daterangestart,daterangeend,datemorethan,datelessthan,",
      newValidate: null
    };
  },
  computed: {
    transInputFormat() {
      if (this.inputFormat === "yyyy-MM") {
        return "yyyy-MM-01";
      }
      return this.inputFormat;
    },
    inputVal: {
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit("input", val);
      }
    },
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    },
    inputValidate: function() {
      if (this.newValidate) {
        return this.newValidate;
      }
      return this.validate;
    }
  },
  mounted() {
    if (this.configAttributes) {
      if (this.configAttributes.isInputEdit) {
        this.isEdit = !this.configAttributes.isInputEdit;
      } else {
        this.isEdit = true;
      }
    } else {
      this.isEdit = true;
    }
  },
  created() {},
  methods: {}
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
